import React, { useState, useEffect, useRef } from 'react';
import './Books.css';
import booksService from '../services/booksService';
import specialitiesService from '../services/specialitiesService';
import subSpecialitiesService from '../services/subSpecialitiesService';
import questionTypesService from '../services/questionTypesService';
import examsService from '../services/examsService';

// Exhaustive list of all countries
const ALL_COUNTRIES = [
  'Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina',
  'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados',
  'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana',
  'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon',
  'Canada', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo',
  'Costa Rica', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica',
  'Dominican Republic', 'East Timor', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea',
  'Estonia', 'Eswatini', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia', 'Georgia',
  'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti',
  'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy',
  'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kosovo', 'Kuwait', 'Kyrgyzstan',
  'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg',
  'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania',
  'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco',
  'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua',
  'Niger', 'Nigeria', 'North Korea', 'North Macedonia', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine',
  'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar',
  'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines',
  'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles',
  'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa',
  'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Sweden', 'Switzerland',
  'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Togo', 'Tonga', 'Trinidad and Tobago',
  'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates',
  'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Venezuela',
  'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
];

// Icon Components
const PlusIcon = () => (
  <svg width="18px" height="18px" strokeWidth="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path d="M6 12H12M18 12H12M12 12V6M12 12V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
);

const EditIcon = () => (
  <svg width="18px" height="18px" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path d="M3 21L12 21H21" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
    <path d="M12.2218 5.82839L15.0503 2.99996L20 7.94971L17.1716 10.7781M12.2218 5.82839L6.61522 11.435C6.42769 11.6225 6.32233 11.8769 6.32233 12.1421L6.32233 16.6776L10.8579 16.6776C11.1231 16.6776 11.3774 16.5723 11.565 16.3847L17.1716 10.7781M12.2218 5.82839L17.1716 10.7781" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
);

const DeleteIcon = () => (
  <svg width="18px" height="18px" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path d="M8.99219 13H11.9922H14.9922" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
    <path d="M3.03919 4.2939C3.01449 4.10866 3.0791 3.92338 3.23133 3.81499C3.9272 3.31953 6.3142 2 12 2C17.6858 2 20.0728 3.31952 20.7687 3.81499C20.9209 3.92338 20.9855 4.10866 20.9608 4.2939L19.2616 17.0378C19.0968 18.2744 18.3644 19.3632 17.2813 19.9821L16.9614 20.1649C13.8871 21.9217 10.1129 21.9217 7.03861 20.1649L6.71873 19.9821C5.6356 19.3632 4.90325 18.2744 4.73838 17.0378L3.03919 4.2939Z" stroke="currentColor" strokeWidth="1.4"></path>
    <path d="M3 5C5.57143 7.66666 18.4286 7.66662 21 5" stroke="currentColor" strokeWidth="1.4"></path>
  </svg>
);

const ProcessIcon = () => (
  <svg width="18px" height="18px" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path d="M8 15C12.8747 15 15 12.949 15 8C15 12.949 17.1104 15 22 15C17.1104 15 15 17.1104 15 22C15 17.1104 12.8747 15 8 15Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"></path>
    <path d="M2 6.5C5.13376 6.5 6.5 5.18153 6.5 2C6.5 5.18153 7.85669 6.5 11 6.5C7.85669 6.5 6.5 7.85669 6.5 11C6.5 7.85669 5.13376 6.5 2 6.5Z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round"></path>
  </svg>
);

const CloseIcon = () => (
  <svg width="14px" height="14px" strokeWidth="2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
);

const UploadIcon = () => (
  <svg width="48px" height="48px" strokeWidth="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
    <path d="M6 20L18 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
    <path d="M12 16V4M12 4L15.5 7.5M12 4L8.5 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
  </svg>
);

const Books = () => {
  // Available options
  const [availableSpecialities, setAvailableSpecialities] = useState([]);
  const [availableSubSpecialities, setAvailableSubSpecialities] = useState([]);
  const [availableQuestionTypes, setAvailableQuestionTypes] = useState([]);
  const [availableExams, setAvailableExams] = useState([]);

  // Books state
  const [books, setBooks] = useState([]);
  const [filterStatus, setFilterStatus] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [selectAll, setSelectAll] = useState(false);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Drawer states
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerMode, setDrawerMode] = useState('add');
  const [currentEditId, setCurrentEditId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    author: '',
    publication_year: '',
    edition: '',
    isbn: '',
    language: 'English',
    countries: [],
    pages_to_extract: '',
    pages_to_exclude: '',
    speciality_ids: [],
    sub_speciality_ids: [],
    question_type_ids: [],
    exam_ids: [],
    extract_questions: false,
    file: null
  });

  // File upload states
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  // Autocomplete states for multi-select
  const [specialitiesSearchTerm, setSpecialitiesSearchTerm] = useState('');
  const [subSpecialitiesSearchTerm, setSubSpecialitiesSearchTerm] = useState('');
  const [questionTypesSearchTerm, setQuestionTypesSearchTerm] = useState('');
  const [examsSearchTerm, setExamsSearchTerm] = useState('');
  const [countriesSearchTerm, setCountriesSearchTerm] = useState('');
  const [showSpecialitiesSuggestions, setShowSpecialitiesSuggestions] = useState(false);
  const [showSubSpecialitiesSuggestions, setShowSubSpecialitiesSuggestions] = useState(false);
  const [showQuestionTypesSuggestions, setShowQuestionTypesSuggestions] = useState(false);
  const [showExamsSuggestions, setShowExamsSuggestions] = useState(false);
  const [showCountriesSuggestions, setShowCountriesSuggestions] = useState(false);

  const specialitiesAutocompleteRef = useRef(null);
  const subSpecialitiesAutocompleteRef = useRef(null);
  const questionTypesAutocompleteRef = useRef(null);
  const examsAutocompleteRef = useRef(null);
  const countriesAutocompleteRef = useRef(null);

  // Delete modal states
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  // Process modal states
  const [isProcessModalOpen, setIsProcessModalOpen] = useState(false);
  const [processTargetId, setProcessTargetId] = useState(null);
  const [processSuccessMessage, setProcessSuccessMessage] = useState('');

  // Debounce search term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
      setCurrentPage(1);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchTerm]);

  // Fetch available options
  useEffect(() => {
    fetchAvailableOptions();
  }, []);

  // Fetch books
  useEffect(() => {
    fetchBooks();
  }, [currentPage, itemsPerPage, filterStatus, debouncedSearchTerm]);

  // Close suggestions on click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (specialitiesAutocompleteRef.current && !specialitiesAutocompleteRef.current.contains(event.target)) {
        setShowSpecialitiesSuggestions(false);
      }
      if (subSpecialitiesAutocompleteRef.current && !subSpecialitiesAutocompleteRef.current.contains(event.target)) {
        setShowSubSpecialitiesSuggestions(false);
      }
      if (questionTypesAutocompleteRef.current && !questionTypesAutocompleteRef.current.contains(event.target)) {
        setShowQuestionTypesSuggestions(false);
      }
      if (examsAutocompleteRef.current && !examsAutocompleteRef.current.contains(event.target)) {
        setShowExamsSuggestions(false);
      }
      if (countriesAutocompleteRef.current && !countriesAutocompleteRef.current.contains(event.target)) {
        setShowCountriesSuggestions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const fetchAvailableOptions = async () => {
    try {
      const [specialitiesRes, subSpecialitiesRes, questionTypesRes, examsRes] = await Promise.all([
        specialitiesService.getAll({ page: 1, limit: 1000, status: 'active' }),
        subSpecialitiesService.getAll({ page: 1, limit: 1000, status: 'active' }),
        questionTypesService.getAll({ page: 1, limit: 1000, status: 'active' }),
        examsService.getAll({ page: 1, limit: 1000, status: 'active' })
      ]);

      setAvailableSpecialities(specialitiesRes.data);
      setAvailableSubSpecialities(subSpecialitiesRes.data);
      setAvailableQuestionTypes(questionTypesRes.data);
      setAvailableExams(examsRes.data);
    } catch (err) {
      console.error('Error fetching options:', err);
    }
  };

  const fetchBooks = async () => {
    try {
      setLoading(true);
      setError(null);

      const params = {
        page: currentPage,
        limit: itemsPerPage,
        search: debouncedSearchTerm,
        status: filterStatus
      };

      const response = await booksService.getAll(params);

      setBooks(response.data.map(book => ({ ...book, selected: false })));
      setTotalPages(response.pagination.totalPages);
      setTotalItems(response.pagination.total);
      setCurrentPage(response.pagination.page);

    } catch (err) {
      console.error('Error fetching books:', err);
      setError('Failed to load books. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setBooks(books.map(book => ({ ...book, selected: newSelectAll })));
  };

  const handleSelectOne = (id) => {
    setBooks(books.map(book =>
      book.id === id ? { ...book, selected: !book.selected } : book
    ));
  };

  const handleEdit = async (id) => {
    try {
      // Fetch full book details with associations
      const response = await booksService.getById(id);
      const book = response.data;

      if (book) {
        let countriesArray = [];
        try {
          if (book.countries) {
            countriesArray = typeof book.countries === 'string' ? JSON.parse(book.countries) : book.countries;
          }
        } catch (e) {
          countriesArray = [];
        }

        setFormData({
          name: book.name,
          author: book.author,
          publication_year: book.publication_year || '',
          edition: book.edition || '',
          isbn: book.isbn || '',
          language: book.language || 'English',
          countries: countriesArray || [],
          pages_to_extract: book.pages_to_extract || '',
          pages_to_exclude: book.pages_to_exclude || '',
          speciality_ids: book.speciality_ids || [],
          sub_speciality_ids: book.sub_speciality_ids || [],
          question_type_ids: book.question_type_ids || [],
          exam_ids: book.exam_ids || [],
          extract_questions: book.extract_questions || false,
          file: null
        });
        setCurrentEditId(id);
        setDrawerMode('edit');
        setSelectedFile(null);
        setFilePreview(null);
        setIsDrawerOpen(true);
      }
    } catch (error) {
      console.error('Error fetching book details:', error);
      alert('Failed to load book details');
    }
  };

  const handleProcess = (id) => {
    setProcessTargetId(id);
    setIsDrawerOpen(false); // Close drawer if open to prevent overlay conflicts
    setIsProcessModalOpen(true);
  };

  const handleConfirmProcess = async () => {
    try {
      const response = await fetch(`/api/books/${processTargetId}/process`, {
        method: 'POST',
        credentials: 'include'
      });

      const data = await response.json();

      if (data.success) {
        setProcessSuccessMessage('Book processing started! Check the status column for progress.');
        // Keep modal open to show success message
        setTimeout(() => {
          setIsProcessModalOpen(false);
          setProcessTargetId(null);
          setProcessSuccessMessage('');
          fetchBooks();
        }, 2000);
      } else {
        alert(data.message || 'Failed to start processing');
        setIsProcessModalOpen(false);
        setProcessTargetId(null);
      }
    } catch (error) {
      console.error('Process error:', error);
      alert('Failed to start processing');
      setIsProcessModalOpen(false);
      setProcessTargetId(null);
    }
  };

  const handleCancelProcess = () => {
    setIsProcessModalOpen(false);
    setProcessTargetId(null);
    setProcessSuccessMessage('');
  };

  const handleDelete = (id) => {
    setDeleteTargetId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await booksService.delete(deleteTargetId);

      setBooks(books.filter(book => book.id !== deleteTargetId));
      setTotalItems(totalItems - 1);
      setIsDeleteModalOpen(false);
      setDeleteTargetId(null);

    } catch (err) {
      console.error('Error deleting book:', err);
      alert('Failed to delete book. Please try again.');
      setIsDeleteModalOpen(false);
      setDeleteTargetId(null);
    }
  };

  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
    setDeleteTargetId(null);
  };

  const handleAddNew = () => {
    setFormData({
      name: '',
      author: '',
      publication_year: '',
      edition: '',
      isbn: '',
      language: 'English',
      countries: [],
      pages_to_extract: '',
      pages_to_exclude: '',
      speciality_ids: [],
      sub_speciality_ids: [],
      question_type_ids: [],
          exam_ids: [],
      file: null
    });
    setDrawerMode('add');
    setCurrentEditId(null);
    setSelectedFile(null);
    setFilePreview(null);
    setIsUploading(false);
    setUploadProgress(0);
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setFormData({
      name: '',
      author: '',
      publication_year: '',
      edition: '',
      isbn: '',
      language: 'English',
      countries: [],
      pages_to_extract: '',
      pages_to_exclude: '',
      speciality_ids: [],
      sub_speciality_ids: [],
      question_type_ids: [],
          exam_ids: [],
      file: null
    });
    setCurrentEditId(null);
    setSelectedFile(null);
    setFilePreview(null);
    setIsUploading(false);
    setUploadProgress(0);
    setSpecialitiesSearchTerm('');
    setSubSpecialitiesSearchTerm('');
    setQuestionTypesSearchTerm('');
    setExamsSearchTerm('');
    setShowSpecialitiesSuggestions(false);
    setShowSubSpecialitiesSuggestions(false);
    setShowQuestionTypesSuggestions(false);
    setShowExamsSuggestions(false);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== 'application/pdf') {
        alert('Only PDF files are allowed');
        return;
      }
      setSelectedFile(file);
      setFilePreview({
        name: file.name,
        size: (file.size / (1024 * 1024)).toFixed(2) + ' MB'
      });
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const file = e.dataTransfer.files[0];
    if (file) {
      if (file.type !== 'application/pdf') {
        alert('Only PDF files are allowed');
        return;
      }
      setSelectedFile(file);
      setFilePreview({
        name: file.name,
        size: (file.size / (1024 * 1024)).toFixed(2) + ' MB'
      });
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      if (drawerMode === 'add') {
        if (!selectedFile) {
          alert('Please select a PDF file');
          return;
        }

        setIsUploading(true);
        setUploadProgress(0);

        const formDataToSend = new FormData();
        formDataToSend.append('file', selectedFile);
        formDataToSend.append('name', formData.name);
        formDataToSend.append('author', formData.author);
        if (formData.publication_year) formDataToSend.append('publication_year', formData.publication_year);
        if (formData.edition) formDataToSend.append('edition', formData.edition);
        if (formData.isbn) formDataToSend.append('isbn', formData.isbn);
        formDataToSend.append('language', formData.language);
        if (formData.countries && formData.countries.length > 0) {
          formDataToSend.append('countries', JSON.stringify(formData.countries));
        }
        if (formData.pages_to_extract) formDataToSend.append('pages_to_extract', formData.pages_to_extract);
        if (formData.pages_to_exclude) formDataToSend.append('pages_to_exclude', formData.pages_to_exclude);
        formDataToSend.append('extract_questions', formData.extract_questions ? '1' : '0');

        // Add array fields
        formData.speciality_ids.forEach(id => formDataToSend.append('speciality_ids', id));
        formData.sub_speciality_ids.forEach(id => formDataToSend.append('sub_speciality_ids', id));
        formData.question_type_ids.forEach(id => formDataToSend.append('question_type_ids', id));
        formData.exam_ids.forEach(id => formDataToSend.append('exam_ids', id));

        const response = await booksService.createWithProgress(formDataToSend, (progress) => {
          setUploadProgress(progress);
        });

        setBooks([{ ...response.data, selected: false }, ...books]);
        setTotalItems(totalItems + 1);
        setIsUploading(false);
        setUploadProgress(0);

      } else {
        const updateData = {
          name: formData.name,
          author: formData.author,
          publication_year: formData.publication_year || null,
          edition: formData.edition || null,
          isbn: formData.isbn || null,
          language: formData.language,
          countries: formData.countries,
          pages_to_extract: formData.pages_to_extract || null,
          pages_to_exclude: formData.pages_to_exclude || null,
          speciality_ids: formData.speciality_ids,
          sub_speciality_ids: formData.sub_speciality_ids,
          question_type_ids: formData.question_type_ids,
          exam_ids: formData.exam_ids,
          extract_questions: formData.extract_questions
        };

        const response = await booksService.update(currentEditId, updateData);

        setBooks(books.map(book =>
          book.id === currentEditId ? { ...response.data, selected: false } : book
        ));
      }

      handleCloseDrawer();

    } catch (err) {
      console.error('Error saving book:', err);
      if (err.response?.data?.message) {
        alert(err.response.data.message);
      } else {
        alert('Failed to save book. Please try again.');
      }
    }
  };

  // Multi-select handlers
  const handleAddSpeciality = (id) => {
    if (!formData.speciality_ids.includes(id)) {
      setFormData(prev => ({
        ...prev,
        speciality_ids: [...prev.speciality_ids, id]
      }));
    }
    setSpecialitiesSearchTerm('');
    setShowSpecialitiesSuggestions(false);
  };

  const handleRemoveSpeciality = (id) => {
    setFormData(prev => ({
      ...prev,
      speciality_ids: prev.speciality_ids.filter(specId => specId !== id)
    }));
  };

  const handleAddSubSpeciality = (id) => {
    if (!formData.sub_speciality_ids.includes(id)) {
      setFormData(prev => ({
        ...prev,
        sub_speciality_ids: [...prev.sub_speciality_ids, id]
      }));
    }
    setSubSpecialitiesSearchTerm('');
    setShowSubSpecialitiesSuggestions(false);
  };

  const handleRemoveSubSpeciality = (id) => {
    setFormData(prev => ({
      ...prev,
      sub_speciality_ids: prev.sub_speciality_ids.filter(subSpecId => subSpecId !== id)
    }));
  };

  const handleAddQuestionType = (id) => {
    if (!formData.question_type_ids.includes(id)) {
      setFormData(prev => ({
        ...prev,
        question_type_ids: [...prev.question_type_ids, id]
      }));
    }
    setQuestionTypesSearchTerm('');
    setShowQuestionTypesSuggestions(false);
  };

  const handleRemoveQuestionType = (id) => {
    setFormData(prev => ({
      ...prev,
      question_type_ids: prev.question_type_ids.filter(qtId => qtId !== id)
    }));
  };

  const handleAddExam = (id) => {
    if (!formData.exam_ids.includes(id)) {
      setFormData(prev => ({
        ...prev,
        exam_ids: [...prev.exam_ids, id]
      }));
    }
    setExamsSearchTerm('');
    setShowExamsSuggestions(false);
  };

  const handleRemoveExam = (id) => {
    setFormData(prev => ({
      ...prev,
      exam_ids: prev.exam_ids.filter(examId => examId !== id)
    }));
  };

  const handleAddCountry = (country) => {
    if (!formData.countries.includes(country)) {
      setFormData(prev => ({
        ...prev,
        countries: [...prev.countries, country]
      }));
    }
    setCountriesSearchTerm('');
    setShowCountriesSuggestions(false);
  };

  const handleRemoveCountry = (country) => {
    setFormData(prev => ({
      ...prev,
      countries: prev.countries.filter(c => c !== country)
    }));
  };

  // Get names for IDs
  const getSpecialityName = (id) => {
    const spec = availableSpecialities.find(s => s.id === id);
    return spec ? spec.name : '';
  };

  const getSubSpecialityName = (id) => {
    const subSpec = availableSubSpecialities.find(s => s.id === id);
    return subSpec ? subSpec.name : '';
  };

  const getQuestionTypeName = (id) => {
    const qt = availableQuestionTypes.find(q => q.id === id);
    return qt ? qt.name : '';
  };

  const getExamName = (id) => {
    const exam = availableExams.find(e => e.id === id);
    return exam ? exam.name : '';
  };

  // Filter suggestions
  const getFilteredSpecialities = () => {
    if (!specialitiesSearchTerm.trim()) return [];
    return availableSpecialities.filter(spec =>
      !formData.speciality_ids.includes(spec.id) &&
      spec.name.toLowerCase().includes(specialitiesSearchTerm.toLowerCase())
    );
  };

  const getFilteredSubSpecialities = () => {
    if (!subSpecialitiesSearchTerm.trim()) return [];
    return availableSubSpecialities.filter(subSpec =>
      !formData.sub_speciality_ids.includes(subSpec.id) &&
      subSpec.name.toLowerCase().includes(subSpecialitiesSearchTerm.toLowerCase())
    );
  };

  const getFilteredQuestionTypes = () => {
    if (!questionTypesSearchTerm.trim()) return [];
    return availableQuestionTypes.filter(qt =>
      !formData.question_type_ids.includes(qt.id) &&
      qt.name.toLowerCase().includes(questionTypesSearchTerm.toLowerCase())
    );
  };

  const getFilteredExams = () => {
    if (!examsSearchTerm.trim()) return [];
    return availableExams.filter(exam =>
      !formData.exam_ids.includes(exam.id) &&
      exam.name.toLowerCase().includes(examsSearchTerm.toLowerCase())
    );
  };

  const getFilteredCountries = () => {
    if (!countriesSearchTerm.trim()) return [];
    return ALL_COUNTRIES.filter(country =>
      !formData.countries.includes(country) &&
      country.toLowerCase().includes(countriesSearchTerm.toLowerCase())
    );
  };

  // Get status badge class
  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'completed': return 'status-completed';
      case 'processing': return 'status-processing';
      case 'failed': return 'status-failed';
      default: return 'status-pending';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'completed': return 'Completed';
      case 'processing': return 'Processing';
      case 'failed': return 'Failed';
      default: return 'Pending';
    }
  };

  return (
    <div className="books-container">
      <div className="books-header">
        <div className="header-left">
          <h1 className="page-title">Knowledgebase</h1>
          <p className="page-description">Manage medical books and literature</p>
        </div>
        <div className="header-right">
          <select
            className="filter-select"
            value={filterStatus}
            onChange={(e) => {
              setFilterStatus(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="all">All Status</option>
            <option value="pending">Pending</option>
            <option value="processing">Processing</option>
            <option value="completed">Completed</option>
            <option value="failed">Failed</option>
          </select>
          <button className="add-btn" onClick={handleAddNew}>
            <PlusIcon />
            <span>Add Book</span>
          </button>
        </div>
      </div>

      <div className="search-bar">
        <input
          type="text"
          placeholder="Search books by name, author, or ISBN..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>

      <div className="table-container">
        <table className="books-table">
          <thead>
            <tr>
              <th className="checkbox-col">
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                  className="checkbox"
                />
              </th>
              <th className="book-col">Book Details</th>
              <th className="author-col">Author</th>
              <th className="meta-col">Metadata</th>
              <th className="speciality-exam-col">Speciality / Exams</th>
              <th className="status-col">Status</th>
              <th className="actions-col">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="7" className="loading-state">
                  Loading books...
                </td>
              </tr>
            ) : error ? (
              <tr>
                <td colSpan="7" className="error-state">
                  {error}
                </td>
              </tr>
            ) : books.length > 0 ? (
              books.map((book) => (
                <tr key={book.id}>
                  <td className="checkbox-col">
                    <input
                      type="checkbox"
                      checked={book.selected}
                      onChange={() => handleSelectOne(book.id)}
                      className="checkbox"
                    />
                  </td>
                  <td className="book-col">
                    <div className="book-details">
                      <span className="book-name">
                        {book.name}
                        {book.extract_questions && <span className="qb-badge" title="Question Bank Enabled">QB</span>}
                      </span>
                      {book.edition && <span className="book-edition">{book.edition}</span>}
                    </div>
                  </td>
                  <td className="author-col">
                    <span className="author-name">{book.author}</span>
                  </td>
                  <td className="meta-col">
                    <div className="meta-info">
                      {book.publication_year && <span className="meta-item">Year: {book.publication_year}</span>}
                      {book.isbn && <span className="meta-item">ISBN: {book.isbn}</span>}
                      {book.total_pages && <span className="meta-item">{book.total_pages} pages</span>}
                    </div>
                  </td>
                  <td className="speciality-exam-col">
                    <div className="speciality-exam-info">
                      {book.speciality_names && book.speciality_names.length > 0 && (
                        <div style={{ marginBottom: '4px' }}>
                          <span style={{ fontSize: '12px', color: '#666', fontWeight: 500 }}>Specialities: </span>
                          <span style={{ fontSize: '12px', color: '#333' }}>{book.speciality_names.join(', ')}</span>
                        </div>
                      )}
                      {book.exam_names && book.exam_names.length > 0 && (
                        <div>
                          <span style={{ fontSize: '12px', color: '#666', fontWeight: 500 }}>Exams: </span>
                          <span style={{ fontSize: '12px', color: '#333' }}>{book.exam_names.join(', ')}</span>
                        </div>
                      )}
                    </div>
                  </td>
                  <td className="status-col">
                    <span className={`status-badge ${getStatusBadgeClass(book.processing_status)}`}>
                      {getStatusText(book.processing_status)}
                    </span>
                    {book.processing_status === 'processing' && book.processing_progress > 0 && (
                      <div className="progress-bar">
                        <div className="progress-fill" style={{ width: `${book.processing_progress}%` }}></div>
                      </div>
                    )}
                  </td>
                  <td className="actions-col">
                    <div className="action-buttons">
                      {book.processing_status === 'pending' && (
                        <button
                          className="action-btn process-btn"
                          onClick={() => handleProcess(book.id)}
                          title="Process Book"
                        >
                          <ProcessIcon />
                        </button>
                      )}
                      <button
                        className="action-btn edit-btn"
                        onClick={() => handleEdit(book.id)}
                        title="Edit"
                      >
                        <EditIcon />
                      </button>
                      <button
                        className="action-btn delete-btn"
                        onClick={() => handleDelete(book.id)}
                        title="Delete"
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="no-data">
                  No books found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      {!loading && !error && totalItems > 0 && (
        <div className="pagination">
          <div className="pagination-left">
            <span className="pagination-label">Show</span>
            <select
              className="pagination-select"
              value={itemsPerPage}
              onChange={(e) => {
                setItemsPerPage(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </select>
            <span className="pagination-label">entries</span>
          </div>
          <div className="pagination-center">
            <span className="pagination-info">
              Page {currentPage} of {totalPages} ({totalItems} total)
            </span>
          </div>
          <div className="pagination-right">
            <button
              className="pagination-btn"
              onClick={() => setCurrentPage(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <button
              className="pagination-btn"
              onClick={() => setCurrentPage(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      )}

      {/* Drawer */}
      {isDrawerOpen && (
        <div className="drawer-overlay open" onClick={handleCloseDrawer}></div>
      )}
      <div className={`drawer ${isDrawerOpen ? 'open' : ''}`}>
        <div className="drawer-header">
          <h2 className="drawer-title">
            {drawerMode === 'add' ? 'Add New Book' : 'Edit Book'}
          </h2>
          <button className="drawer-close" onClick={handleCloseDrawer}>
            <svg width="24px" height="24px" strokeWidth="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor">
              <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
            </svg>
          </button>
        </div>

        <form onSubmit={handleFormSubmit} className="drawer-form">
          {/* File Upload Section */}
          {drawerMode === 'add' && (
            <div className="form-group file-upload-section">
              <label className="form-label">PDF File *</label>
              <div
                className={`file-drop-zone ${selectedFile ? 'has-file' : ''}`}
                onClick={() => fileInputRef.current?.click()}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                {selectedFile ? (
                  <div className="file-preview">
                    <div className="file-icon">📄</div>
                    <div className="file-info">
                      <div className="file-name">{filePreview.name}</div>
                      <div className="file-size">{filePreview.size}</div>
                    </div>
                    <button
                      type="button"
                      className="file-remove"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedFile(null);
                        setFilePreview(null);
                        if (fileInputRef.current) fileInputRef.current.value = '';
                      }}
                    >
                      <CloseIcon />
                    </button>
                  </div>
                ) : (
                  <div className="file-upload-placeholder">
                    <UploadIcon />
                    <p>Click to upload or drag and drop</p>
                    <p className="file-requirements">PDF files only (max 500MB)</p>
                  </div>
                )}
              </div>
              <input
                ref={fileInputRef}
                type="file"
                accept=".pdf,application/pdf"
                onChange={handleFileChange}
                style={{ display: 'none' }}
              />
            </div>
          )}

          {/* Book Name */}
          <div className="form-group">
            <label htmlFor="name" className="form-label">Book Name *</label>
            <input
              type="text"
              id="name"
              className="form-input"
              value={formData.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              placeholder="Enter book name"
              required
            />
          </div>

          {/* Author */}
          <div className="form-group">
            <label htmlFor="author" className="form-label">Author *</label>
            <input
              type="text"
              id="author"
              className="form-input"
              value={formData.author}
              onChange={(e) => setFormData({ ...formData, author: e.target.value })}
              placeholder="Enter author name(s)"
              required
            />
          </div>

          {/* Two Column Layout */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="publication_year" className="form-label">Publication Year</label>
              <input
                type="number"
                id="publication_year"
                className="form-input"
                value={formData.publication_year}
                onChange={(e) => setFormData({ ...formData, publication_year: e.target.value })}
                placeholder="e.g., 2024"
                min="1900"
                max="2100"
              />
            </div>

            <div className="form-group">
              <label htmlFor="edition" className="form-label">Edition</label>
              <input
                type="text"
                id="edition"
                className="form-input"
                value={formData.edition}
                onChange={(e) => setFormData({ ...formData, edition: e.target.value })}
                placeholder="e.g., 21st Edition"
              />
            </div>
          </div>

          {/* Two Column Layout */}
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="isbn" className="form-label">ISBN</label>
              <input
                type="text"
                id="isbn"
                className="form-input"
                value={formData.isbn}
                onChange={(e) => setFormData({ ...formData, isbn: e.target.value })}
                placeholder="Enter ISBN"
              />
            </div>

            <div className="form-group">
              <label htmlFor="language" className="form-label">Language</label>
              <select
                id="language"
                className="form-input"
                value={formData.language}
                onChange={(e) => setFormData({ ...formData, language: e.target.value })}
              >
                <option value="English">English</option>
                <option value="Hindi">Hindi</option>
                <option value="Spanish">Spanish</option>
                <option value="French">French</option>
                <option value="German">German</option>
                <option value="Other">Other</option>
              </select>
            </div>
          </div>

          {/* Countries Multi-Select */}
          <div className="form-group">
            <label className="form-label">Applicable Countries (Optional)</label>
            <div className="autocomplete-container" ref={countriesAutocompleteRef}>
              <input
                type="text"
                className="form-input"
                value={countriesSearchTerm}
                onChange={(e) => {
                  setCountriesSearchTerm(e.target.value);
                  setShowCountriesSuggestions(true);
                }}
                onFocus={() => setShowCountriesSuggestions(true)}
                placeholder="Type to search countries..."
              />

              {showCountriesSuggestions && getFilteredCountries().length > 0 && (
                <div className="suggestions-dropdown">
                  {getFilteredCountries().map((country) => (
                    <div
                      key={country}
                      className="suggestion-item"
                      onClick={() => handleAddCountry(country)}
                    >
                      {country}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {formData.countries.length > 0 && (
              <div className="selected-items">
                {formData.countries.map((country) => (
                  <div key={country} className="selected-item-card">
                    <span className="selected-item-name">{country}</span>
                    <button
                      type="button"
                      className="remove-item-btn"
                      onClick={() => handleRemoveCountry(country)}
                      title="Remove"
                    >
                      <CloseIcon />
                    </button>
                  </div>
                ))}
              </div>
            )}
            <small style={{ display: 'block', marginTop: '4px', color: '#666' }}>
              Leave empty if applicable globally.
            </small>
          </div>

          {/* Pages Configuration */}
          <div className="form-group">
            <label htmlFor="pages_to_extract" className="form-label">Pages to Extract</label>
            <input
              type="text"
              id="pages_to_extract"
              className="form-input"
              value={formData.pages_to_extract}
              onChange={(e) => setFormData({ ...formData, pages_to_extract: e.target.value })}
              placeholder="e.g., 1-50, 75-80, 100"
            />
            <span className="form-hint">Leave empty to extract all pages</span>
          </div>

          <div className="form-group">
            <label htmlFor="pages_to_exclude" className="form-label">Pages to Exclude</label>
            <input
              type="text"
              id="pages_to_exclude"
              className="form-input"
              value={formData.pages_to_exclude}
              onChange={(e) => setFormData({ ...formData, pages_to_exclude: e.target.value })}
              placeholder="e.g., 1-5, 100-105"
            />
            <span className="form-hint">Optional: Skip cover pages, index, etc.</span>
          </div>

          {/* Extract Questions Toggle */}
          <div className="form-group">
            <label className="toggle-label">
              <input
                type="checkbox"
                checked={formData.extract_questions}
                onChange={(e) => setFormData({ ...formData, extract_questions: e.target.checked })}
                className="toggle-checkbox"
              />
              <span className="toggle-switch"></span>
              <span className="toggle-text">
                <strong>Extract MCQ Questions</strong>
                <small>Enable automatic question extraction from this book's PDF</small>
              </span>
            </label>
          </div>

          {/* Specialities Multi-Select */}
          <div className="form-group">
            <label className="form-label">Specialities</label>
            <div className="autocomplete-container" ref={specialitiesAutocompleteRef}>
              <input
                type="text"
                className="form-input"
                value={specialitiesSearchTerm}
                onChange={(e) => {
                  setSpecialitiesSearchTerm(e.target.value);
                  setShowSpecialitiesSuggestions(true);
                }}
                onFocus={() => setShowSpecialitiesSuggestions(true)}
                placeholder="Type to search specialities..."
              />

              {showSpecialitiesSuggestions && getFilteredSpecialities().length > 0 && (
                <div className="suggestions-dropdown">
                  {getFilteredSpecialities().map((spec) => (
                    <div
                      key={spec.id}
                      className="suggestion-item"
                      onClick={() => handleAddSpeciality(spec.id)}
                    >
                      {spec.name}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {formData.speciality_ids.length > 0 && (
              <div className="selected-items">
                {formData.speciality_ids.map((specId) => (
                  <div key={specId} className="selected-item-card">
                    <span className="selected-item-name">{getSpecialityName(specId)}</span>
                    <button
                      type="button"
                      className="remove-item-btn"
                      onClick={() => handleRemoveSpeciality(specId)}
                      title="Remove"
                    >
                      <CloseIcon />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Sub-Specialities Multi-Select */}
          <div className="form-group">
            <label className="form-label">Sub-Specialities</label>
            <div className="autocomplete-container" ref={subSpecialitiesAutocompleteRef}>
              <input
                type="text"
                className="form-input"
                value={subSpecialitiesSearchTerm}
                onChange={(e) => {
                  setSubSpecialitiesSearchTerm(e.target.value);
                  setShowSubSpecialitiesSuggestions(true);
                }}
                onFocus={() => setShowSubSpecialitiesSuggestions(true)}
                placeholder="Type to search sub-specialities..."
              />

              {showSubSpecialitiesSuggestions && getFilteredSubSpecialities().length > 0 && (
                <div className="suggestions-dropdown">
                  {getFilteredSubSpecialities().map((subSpec) => (
                    <div
                      key={subSpec.id}
                      className="suggestion-item"
                      onClick={() => handleAddSubSpeciality(subSpec.id)}
                    >
                      {subSpec.name}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {formData.sub_speciality_ids.length > 0 && (
              <div className="selected-items">
                {formData.sub_speciality_ids.map((subSpecId) => (
                  <div key={subSpecId} className="selected-item-card">
                    <span className="selected-item-name">{getSubSpecialityName(subSpecId)}</span>
                    <button
                      type="button"
                      className="remove-item-btn"
                      onClick={() => handleRemoveSubSpeciality(subSpecId)}
                      title="Remove"
                    >
                      <CloseIcon />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Question Types Multi-Select */}
          <div className="form-group">
            <label className="form-label">Question Types</label>
            <div className="autocomplete-container" ref={questionTypesAutocompleteRef}>
              <input
                type="text"
                className="form-input"
                value={questionTypesSearchTerm}
                onChange={(e) => {
                  setQuestionTypesSearchTerm(e.target.value);
                  setShowQuestionTypesSuggestions(true);
                }}
                onFocus={() => setShowQuestionTypesSuggestions(true)}
                placeholder="Type to search question types..."
              />

              {showQuestionTypesSuggestions && getFilteredQuestionTypes().length > 0 && (
                <div className="suggestions-dropdown">
                  {getFilteredQuestionTypes().map((qt) => (
                    <div
                      key={qt.id}
                      className="suggestion-item"
                      onClick={() => handleAddQuestionType(qt.id)}
                    >
                      {qt.name}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {formData.question_type_ids.length > 0 && (
              <div className="selected-items">
                {formData.question_type_ids.map((qtId) => (
                  <div key={qtId} className="selected-item-card">
                    <span className="selected-item-name">{getQuestionTypeName(qtId)}</span>
                    <button
                      type="button"
                      className="remove-item-btn"
                      onClick={() => handleRemoveQuestionType(qtId)}
                      title="Remove"
                    >
                      <CloseIcon />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Exams Multi-Select */}
          <div className="form-group">
            <label className="form-label">Exams (Optional)</label>
            <div className="autocomplete-container" ref={examsAutocompleteRef}>
              <input
                type="text"
                className="form-input"
                value={examsSearchTerm}
                onChange={(e) => {
                  setExamsSearchTerm(e.target.value);
                  setShowExamsSuggestions(true);
                }}
                onFocus={() => setShowExamsSuggestions(true)}
                placeholder="Type to search exams..."
              />

              {showExamsSuggestions && getFilteredExams().length > 0 && (
                <div className="suggestions-dropdown">
                  {getFilteredExams().map((exam) => (
                    <div
                      key={exam.id}
                      className="suggestion-item"
                      onClick={() => handleAddExam(exam.id)}
                    >
                      {exam.name}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {formData.exam_ids.length > 0 && (
              <div className="selected-items">
                {formData.exam_ids.map((examId) => (
                  <div key={examId} className="selected-item-card">
                    <span className="selected-item-name">{getExamName(examId)}</span>
                    <button
                      type="button"
                      className="remove-item-btn"
                      onClick={() => handleRemoveExam(examId)}
                      title="Remove"
                    >
                      <CloseIcon />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Upload Progress */}
          {isUploading && (
            <div style={{ margin: '20px 0' }}>
              <div style={{ marginBottom: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '14px', color: '#333' }}>Uploading... {uploadProgress}%</span>
              </div>
              <div style={{ width: '100%', height: '8px', backgroundColor: '#e0e0e0', borderRadius: '4px', overflow: 'hidden' }}>
                <div
                  style={{
                    width: `${uploadProgress}%`,
                    height: '100%',
                    backgroundColor: '#4CAF50',
                    transition: 'width 0.3s ease'
                  }}
                />
              </div>
            </div>
          )}

          <div className="drawer-actions">
            <button type="button" className="btn-cancel" onClick={handleCloseDrawer} disabled={isUploading}>
              Cancel
            </button>
            <button type="submit" className="btn-submit" disabled={isUploading}>
              {isUploading ? `Uploading... ${uploadProgress}%` : (drawerMode === 'add' ? 'Upload Book' : 'Update Book')}
            </button>
          </div>
        </form>
      </div>

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <div className="delete-modal-wrapper">
          <div className="delete-modal-overlay" onClick={handleCancelDelete}></div>
          <div className="delete-modal-content">
            <div className="modal-icon">
              <svg width="48px" height="48px" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#F07167">
                <path d="M8.99219 13H11.9922H14.9922" stroke="#F07167" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                <path d="M3.03919 4.2939C3.01449 4.10866 3.0791 3.92338 3.23133 3.81499C3.9272 3.31953 6.3142 2 12 2C17.6858 2 20.0728 3.31952 20.7687 3.81499C20.9209 3.92338 20.9855 4.10866 20.9608 4.2939L19.2616 17.0378C19.0968 18.2744 18.3644 19.3632 17.2813 19.9821L16.9614 20.1649C13.8871 21.9217 10.1129 21.9217 7.03861 20.1649L6.71873 19.9821C5.6356 19.3632 4.90325 18.2744 4.73838 17.0378L3.03919 4.2939Z" stroke="#F07167" strokeWidth="1.4"></path>
                <path d="M3 5C5.57143 7.66666 18.4286 7.66662 21 5" stroke="#F07167" strokeWidth="1.4"></path>
              </svg>
            </div>
            <h3 className="modal-title">Delete Book</h3>
            <p className="modal-message">
              Are you sure you want to delete "{books.find(b => b.id === deleteTargetId)?.name}"? This will also delete all associated chunks and embeddings. This action cannot be undone.
            </p>
            <div className="modal-actions">
              <button className="modal-btn modal-btn-cancel" onClick={handleCancelDelete}>
                Cancel
              </button>
              <button className="modal-btn modal-btn-delete" onClick={handleConfirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Process Confirmation Modal */}
      {isProcessModalOpen && (
        <div className="process-modal-wrapper">
          <div className="process-modal-overlay" onClick={processSuccessMessage ? null : handleCancelProcess}></div>
          <div className="process-modal-content">
            {processSuccessMessage ? (
              <>
                <div className="modal-icon">
                  <svg width="48px" height="48px" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#00AF54">
                    <path d="M5 13L9 17L19 7" stroke="#00AF54" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"></path>
                  </svg>
                </div>
                <h3 className="modal-title">Processing Started</h3>
                <p className="modal-message">{processSuccessMessage}</p>
              </>
            ) : (
              <>
                <div className="modal-icon">
                  <svg width="48px" height="48px" strokeWidth="1.4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="#00AF54">
                    <path d="M8 15C12.8747 15 15 12.949 15 8C15 12.949 17.1104 15 22 15C17.1104 15 15 17.1104 15 22C15 17.1104 12.8747 15 8 15Z" stroke="#00AF54" strokeWidth="1.4" strokeLinejoin="round"></path>
                    <path d="M2 6.5C5.13376 6.5 6.5 5.18153 6.5 2C6.5 5.18153 7.85669 6.5 11 6.5C7.85669 6.5 6.5 7.85669 6.5 11C6.5 7.85669 5.13376 6.5 2 6.5Z" stroke="#00AF54" strokeWidth="1.4" strokeLinejoin="round"></path>
                  </svg>
                </div>
                <h3 className="modal-title">Process Book</h3>
                <p className="modal-message">
                  Start processing "{books.find(b => b.id === processTargetId)?.name}"? This will extract text, generate chunks, and create embeddings. The process will run in the background.
                </p>
                <div className="modal-actions">
                  <button className="modal-btn modal-btn-cancel" onClick={handleCancelProcess}>
                    Cancel
                  </button>
                  <button className="modal-btn modal-btn-process" onClick={handleConfirmProcess}>
                    Start Processing
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Books;
